@if (paginatedProducts().length === 0) {
  <app-empty-data
    [title]="
      isFilterApplied()
        ? isArabic()
          ? 'لا توجد أصناف مطابقة لمعايير البحث'
          : 'No products found matching your criteria'
        : isArabic()
          ? 'لا توجد أصناف متاحة'
          : 'No products available'
    "
    [description]="
      !isFilterApplied()
        ? isArabic()
          ? 'اضغط على «إضافة صنف» لإنشاء أول صنف لك'
          : 'Click \'Add Product\' to create your first product.'
        : null
    "
    [ctaButton]="!isFilterApplied() ? (isArabic() ? 'إضافة صنف' : 'Add Product') : null"
    (cta)="!isFilterApplied ? ctaEmptyState() : null" />
} @else {
  <div class="mt-4 grid grid-cols-1 gap-6 sm:grid-cols-2 lg:grid-cols-3 2xl:grid-cols-4">
    <!-- <div class="mt-4 flex flex-wrap items-center justify-center gap-6"> -->
    @for (product of paginatedProducts(); track product.id) {
      <div
        (click)="onNavigateToProduct(product.id.toString())"
        class="group relative flex w-[18rem] cursor-pointer flex-col overflow-hidden rounded-xl border-1 border-gray-200 bg-white transition-all hover:shadow-lg">
        <div class="absolute top-2 right-2 z-20">
          <button
            (click)="onToggleDropDown(product.id, $event)"
            class="cursor-pointer rounded-full bg-white/80 p-1 text-gray-600 shadow-sm hover:bg-white">
            <svg class="h-5 w-5" fill="currentColor" viewBox="0 0 24 24">
              <path
                d="M12 8c1.1 0 2-.9 2-2s-.9-2-2-2-2 .9-2 2 .9 2 2 2zm0 2c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2zm0 6c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2z"></path>
            </svg>
          </button>

          @if (activeDropdownId() === product.id) {
            <div
              [class]="isArabic() ? 'right-[40%]' : 'left-[40%]'"
              class="absolute top-8 z-50 flex w-48 flex-col gap-1 rounded-md border border-gray-200 bg-white p-1 shadow-lg">
              <button
                class="w-full rounded-[4px] px-3 py-2 text-left text-[13px] font-medium text-gray-700 hover:cursor-pointer hover:bg-gray-50"
                i18n="@@adminProductsActionView">
                View Product Details
              </button>
              <button
                (click)="onNavigateToEditProduct($event, product.id)"
                class="w-full rounded-[4px] px-3 py-2 text-left text-[13px] font-medium text-gray-700 hover:cursor-pointer hover:bg-gray-50"
                i18n="@@adminProductsActionEdit">
                Edit Product
              </button>
              <button
                (click)="onDeleteProduct($event, product.id)"
                class="w-full rounded-[4px] px-3 py-2 text-left text-[13px] font-medium text-red-600 hover:cursor-pointer hover:bg-red-50"
                i18n="@@adminProductsActionDelete">
                Delete Product
              </button>
              <div class="flex items-center">
                <app-toggle-button
                  [isActive]="isProductActive(product.id)"
                  (submit)="onActiveConfirmationModal(isProductActive(product.id), product.id)" />
                <button
                  class="w-full rounded-[4px] px-3 py-2 text-left text-[13px] font-medium text-gray-700 hover:cursor-pointer hover:bg-gray-50">
                  @if (isProductActive(product.id)) {
                    <span i18n="@@deactivatedAction">Mark as inactive</span>
                  } @else {
                    <span i18n="@@activatedAction">Mark as active</span>
                  }
                </button>
              </div>
            </div>
          }
        </div>

        <div class="bg-surface-subtle relative flex h-52 w-full items-center justify-center">
          <div class="group bg-surface-subtle relative flex h-52 w-full items-center justify-center overflow-hidden">
            @let imageData = productImages()?.get(product.id.toString());
            @if (imageData && imageData.isImage) {
              <img
                [src]="imageData.url"
                class="h-4/5 w-4/5 object-contain transition-transform duration-700 group-hover:scale-110"
                alt="product image" />
            } @else {
              <div class="flex items-center justify-center transition-transform duration-500 group-hover:scale-110">
                <svg xmlns="http://www.w3.org/2000/svg" width="100" height="100" viewBox="0 0 48 48">
                  <g class="fill-danger-text" opacity="0.8">
                    <path d="M37.084 15.735a1 1 0 1 0 .448-1.949l-6.616-1.52a1 1 0 1 0-.448 1.948z" />
                    <path
                      fill-rule="evenodd"
                      d="M34 22a8 8 0 1 0 0-16a8 8 0 0 0 0 16m0-2a6 6 0 1 0 0-12a6 6 0 0 0 0 12M16.778 9.245c-.647-1.532-2.813-1.686-3.682-.263L6.292 20.115c-.785 1.284.092 2.924 1.623 3.033l11.866.846c1.53.11 2.644-1.388 2.06-2.77zm-1.967.768l-.009.012L8.01 21.14l.002.002l.01.004a.1.1 0 0 0 .036.007l11.867.846h.038a.1.1 0 0 0 .029-.015l-5.056-11.96l-.004-.01a.1.1 0 0 0-.054-.014a.13.13 0 0 0-.062.009l-.003.001v.001z" />
                  </g>
                </svg>
              </div>
            }
          </div>
        </div>

        <div class="flex flex-1 flex-col p-4">
          <h3
            class="truncate text-[15px] font-semibold text-gray-800"
            [title]="isArabic() ? product.titleAr || product.titleEn : product.titleEn">
            {{ isArabic() ? product.titleAr || product.titleEn : product.titleEn }}
          </h3>

          <div class="mt-1 flex items-center justify-between text-[11px] text-gray-400">
            <span>{{ isArabic() ? product.mfgCompany.titleAr : product.mfgCompany.titleEn }}</span>
          </div>

          @if (!hasSubproducts()) {
            <div class="my-4 h-[1px] w-full bg-gray-100"></div>
            <div class="flex items-start justify-between">
              <div class="flex items-center gap-2">
                <div class="text-primary">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="24"
                    height="24"
                    viewBox="0 4 42 42"
                    class="flex-shrink-0">
                    <g class="fill-primary">
                      <path
                        d="M18.305 13c-.057-1.61-.011-3.315.556-4.647c.299-.7.73-1.266 1.354-1.667c.627-.402 1.527-.686 2.843-.686c1.475 0 2.704.536 3.584 1.094c.437.278.778.555 1.007.76a6 6 0 0 1 .31.3l.01.01v.001a1 1 0 0 0 1.496-1.328l-.735.65c.735-.65.733-.652.733-.652v-.001l-.004-.004l-.01-.01a3 3 0 0 0-.122-.13a8 8 0 0 0-.343-.325a10 10 0 0 0-1.27-.96C26.624 4.716 25.024 4 23.058 4c-1.606 0-2.903.349-3.923 1.003c-1.023.657-1.69 1.57-2.114 2.566c-.738 1.733-.774 3.798-.718 5.431H11c-.553 0-1.006.45-.943.998c.615 5.38 6.16 9.643 13.058 9.98V32h2v-8.034a17 17 0 0 0 4.87-1.02q.015.172.015.357c0 .762-.623 1.674-1.901 2.466a8.6 8.6 0 0 1-2.099.924v2.066a10.6 10.6 0 0 0 3.151-1.29C30.624 26.56 32 25.123 32 23.304c0-.41-.038-.815-.123-1.208c3.367-1.804 5.68-4.732 6.066-8.097c.063-.548-.391-.998-.943-.998z" />
                      <path
                        d="M30 39c0 1.165-.36 2.188-1.019 3H32v2H16v-2h7.115v-4h2v3.914c.802-.131 1.436-.404 1.892-.763c.625-.49.993-1.196.993-2.151s-.368-1.66-.993-2.151c-.65-.512-1.662-.85-3.007-.85c-1.517 0-3.2-.119-4.531-.71c-.684-.304-1.315-.75-1.773-1.403c-.462-.66-.696-1.461-.696-2.386s.234-1.726.696-2.386c.458-.653 1.09-1.099 1.773-1.403c.76-.338 1.637-.522 2.531-.617v2.013c-.658.083-1.242.22-1.719.432c-.441.196-.747.438-.946.722c-.194.277-.335.664-.335 1.239s.14.962.335 1.239c.199.284.505.526.946.722c.92.409 2.236.539 3.719.539c1.654 0 3.144.413 4.243 1.276C29.368 36.16 30 37.455 30 39" />
                    </g>
                  </svg>
                </div>
                <div class="flex flex-col">
                  <div class="flex items-center gap-1">
                    <span class="text-[10px] text-gray-400" i18n="@@pharmacyPrice">Pharmacy Price</span>
                    <!-- @if (product.businessPriceDiscountPercentage) {
                      <span class="inline text-[10px] text-gray-400">
                        (
                        <span i18n="@@pharmacyDiscount">Pharmacy Discount</span>
                        {{ product.businessPriceDiscountPercentage }} %
                      </span>
                      )
                    } -->
                  </div>
                  @if (product.businessPrice) {
                    <div class="flex items-start gap-1">
                      @if (product.businessPriceDiscountPercentage) {
                        <div>
                          <div>
                            <span class="text-xl font-bold text-gray-800">{{ product.businessPrice }}</span>
                            @if (product.businessPrice) {
                              <span
                                class="text-[12px] font-medium text-gray-800"
                                [ngClass]="isArabic() ? 'mr-1' : 'ml-1'"
                                i18n="@@EGP">
                                EGP
                              </span>
                            }
                            <span class="mx-2 text-base text-gray-400 line-through">{{ product.customerPrice }}</span>
                            <!-- <span class="text-[10px] font-medium text-gray-400" i18n="@@EGP">EGP</span> -->
                          </div>
                          <div class="block">
                            <span class="text-sm font-bold text-red-600" i18n="@@pharmacyDiscount">Discount</span>
                            <span class="text-sm font-bold text-red-600">
                              {{ product.businessPriceDiscountPercentage }}%
                            </span>
                          </div>
                        </div>
                        <!-- </span> -->
                      } @else {
                        <span class="text-sm font-bold text-gray-800">{{ product.businessPrice }}</span>
                        @if (product.businessPrice) {
                          <span class="text-[10px] font-medium text-gray-500" i18n="@@EGP">EGP</span>
                        }
                      }
                    </div>
                  }
                </div>
              </div>

              <div class="flex items-center gap-2">
                <div class="text-primary">
                  <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                    <path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2" />
                    <circle cx="12" cy="7" r="4" />
                  </svg>
                </div>
                <div class="flex flex-col">
                  <span class="text-[10px] text-gray-400" i18n="@@peoplePrice">People Price</span>
                  <div class="flex items-baseline gap-1">
                    <span class="text-xl font-bold text-gray-800">{{ product.customerPrice }}</span>
                    @if (product.customerPrice) {
                      <span class="text-[12px] font-medium text-gray-800" i18n="@@EGP">EGP</span>
                    }
                  </div>
                </div>
              </div>
            </div>
          }
        </div>
      </div>
    }
  </div>
}

@if (confirmationModal()) {
  <app-confirmation-dialog
    [error]="errorActivation()"
    (onSubmit)="type() === 'deactivate' ? deactivateProduct() : activateProduct()"
    (onCancel)="confirmationModal.set(false)"
    [productType]="hasSubproducts() ? 'has-sub' : 'has-no-sub'"
    [title]="
      isArabic()
        ? type() === 'deactivate'
          ? 'تأكيد إلغاء تفعيل الصنف'
          : 'تأكيد تفعيل الصنف'
        : type() === 'deactivate'
          ? 'Confirm Product Deactivation'
          : 'Confirm Product Activation'
    "
    [description]="confirmationModalContent().description"
    [confirmContent]="confirmationModalContent().confirmContent"
    [type]="type()"
    [cancelContent]="isArabic() ? 'إلغاء' : 'Cancel'" />
}

@if (deleteConfirmationModal()) {
  <app-confirmation-dialog
    [error]="errorDelete()"
    [title]="isArabic() ? 'تأكيد الحذف؟' : 'Confirm Delete?'"
    [description]="
      isArabic() ? 'هل أنت متأكد من رغبتك في حذف هذا الصنف؟' : 'Are you sure you want to delete this product?'
    "
    [confirmContent]="loadingDelete() ? (isArabic() ? 'جارٍ الحذف...' : 'Deleting...') : isArabic() ? 'حذف' : 'Delete'"
    [cancelContent]="isArabic() ? 'إلغاء' : 'Cancel'"
    (onSubmit)="confirmDelete()"
    (onCancel)="deleteConfirmationModal.set(false)" />
}

@if (isSuccessNotification()) {
  <app-successful-notification
    type="success"
    [title]="
      isArabic()
        ? type() === 'deactivate'
          ? 'تم إلغاء تفعيل الصنف'
          : 'تم تفعيل الصنف'
        : type() === 'deactivate'
          ? 'Product deactivated successfully. The product is now hidden from customers.'
          : 'Product activated successfully. The product is now visible to customers.'
    " />
}

@if (deleteSuccess()) {
  <app-successful-notification
    type="success"
    [title]="isArabic() ? 'تم حذف الصنف بنجاح.' : 'Product deleted successfully.'" />
}
